import { defineChain } from 'viem';

export const chainIds = {
  eth: 1,
  arb: 42161,
  base: 8453,
  bsc: 56,
  avax: 43114,
  op: 10,
  pol: 137,
  near: 397
};

// mainnet
export const ethereumMainnet = defineChain({
  id: chainIds.eth,
  name: 'Ethereum',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://ethereum-rpc.publicnode.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Etherscan',
      url: 'https://etherscan.io',
      apiUrl: 'https://api.etherscan.io/api',
    },
  },
  contracts: {
    ensRegistry: {
      address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
    },
    ensUniversalResolver: {
      address: '0xce01f8eee7E479C928F8919abD53E553a36CeF67',
      blockCreated: 19_258_213,
    },
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 14_353_601,
    },
  },
});

export const avalancheMainnet = defineChain({
  id: chainIds.avax,
  name: 'Avalanche',
  iconUrl: 'https://img.cryptorank.io/coins/avalanche1629705441155.png',
  nativeCurrency: { name: 'Avalanche', symbol: 'AVAX', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://api.avax.network/ext/bc/C/rpc'] },
  },
  blockExplorers: {
    default: {
      name: 'Snowtrace',
      url: 'https://snowtrace.io',
    },
  },
});

export const nibiruMainnet = defineChain({
  id: 6900,
  name: 'Nibiru',
  iconUrl: 'https://img.cryptorank.io/coins/nibiru1744727629455.png',
  iconBackground: '#fff',
  nativeCurrency: { name: 'Nibiru', symbol: 'NIBI', decimals: 6 },
  rpcUrls: {
    default: { http: ['https://evm-rpc.nibiru.fi'] },
  },
  blockExplorers: {
    default: { name: 'Nibiru', url: 'https://nibiscan.io' },
  },
});

export const arbitrumMainnet = defineChain({
  id: chainIds.arb,
  name: 'Arbitrum Mainnet',
  iconUrl: 'https://img.cryptorank.io/coins/arbitrum1696871846920.png',
  iconBackground: '#fff',
  nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://arb1.arbitrum.io/rpc'] },
  },
  blockExplorers: {
    default: { name: 'Arbitrum Mainnet', url: 'https://arbiscan.io' },
  },
});

export const bitLayerMainnet = defineChain({
  id: 200901,
  name: 'Bitlayer',
  iconUrl: 'https://img.cryptorank.io/coins/bitlayer1708427921502.png',
  iconBackground: '#fff',
  nativeCurrency: { name: 'BitCoin', symbol: 'BTC', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.bitlayer.org/'] },
  },
  blockExplorers: {
    default: { name: 'BitLayer', url: 'https://www.btrscan.com/' },
  },
});

export const bscMainnet = defineChain({
  id: chainIds.bsc,
  name: 'Binance Smart Chain',
  iconUrl: 'https://img.cryptorank.io/coins/bnb1732530324407.png',
  nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://bsc-dataseed.bnbchain.org'] },
  },
  blockExplorers: {
    default: {
      name: 'BSC Scan',
      url: 'https://bscscan.com',
    },
  },
});
export const sei = defineChain({
  id: 1329,
  name: 'Sei',
  iconUrl: 'https://img.cryptorank.io/coins/sei_network1661962346631.png',
  nativeCurrency: { name: 'Sei', symbol: 'SEI', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://evm-rpc.sei-apis.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Seitrace',
      url: 'https://seitrace.com',
    },
  },
});

export const baseMainnet = defineChain({
  id: chainIds.base,
  name: 'Base',
  iconUrl:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/base/info/logo.png',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://base.drpc.org'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Basescan',
      url: 'https://basescan.org/',
    },
  },
});

export const optimismMainnet = defineChain({
  id: chainIds.op,
  name: 'Optimism',
  iconUrl: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11840.png',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://public-op-mainnet.fastnode.io'],
    },
  },
  blockExplorers: {
    default: {
      name: 'etherscan',
      url: 'https://optimistic.etherscan.io/',
    },
  },
});
export const polygonMainnet = defineChain({
  id: chainIds.pol,
  name: 'Polygon',
  iconUrl: 'https://s2.coinmarketcap.com/static/img/coins/64x64/28321.png',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://polygon-bor-rpc.publicnode.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'polygonscan',
      url: 'https://polygonscan.com/',
    },
  },
});

//Testnet
export const bitLayerTestnet = defineChain({
  id: 200810,
  name: 'Bitlayer Testnet',
  iconUrl: 'https://img.cryptorank.io/coins/bitlayer1708427921502.png',
  iconBackground: '#fff',
  nativeCurrency: { name: 'BitCoin', symbol: 'BTC', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://testnet-rpc.bitlayer.org'] },
  },
  blockExplorers: {
    default: { name: 'BitLayer Testnet', url: 'https://testnet.btrscan.com' },
  },
  testnet: true,
});

export const nibiruTestnet = defineChain({
  id: 6911,
  name: 'Nibiru Testnet',
  iconUrl: 'https://img.cryptorank.io/coins/nibiru1744727629455.png',
  iconBackground: '#fff',
  nativeCurrency: { name: 'Nibiru', symbol: 'NIBI', decimals: 6 },
  rpcUrls: {
    default: { http: ['https://evm-rpc.testnet-2.nibiru.fi'] },
  },
  blockExplorers: {
    default: { name: 'Nibiru Testnet', url: 'https://testnet.nibiscan.io' },
  },
  testnet: true,
});

export const arbitrumTestnet = defineChain({
  id: chainIds.arb,
  name: 'Arbitrum Sepolia',
  iconUrl: 'https://img.cryptorank.io/coins/arbitrum1696871846920.png',
  iconBackground: '#fff',
  nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://sepolia-rollup.arbitrum.io/rpc'] },
  },
  blockExplorers: {
    default: { name: 'Arbitrum Sepolia', url: 'https://sepolia.arbiscan.io' },
  },
  testnet: true,
});

export const sepoliaConfig = defineChain({
  id: 11_155_111,
  name: 'Sepolia',
  iconUrl: 'https://img.cryptorank.io/coins/ethereum1524754015525.png',
  nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://endpoints.omniatech.io/v1/eth/sepolia/public'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Etherscan',
      url: 'https://sepolia.etherscan.io',
      apiUrl: 'https://api-sepolia.etherscan.io/api',
    },
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 751532,
    },
    ensRegistry: { address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e' },
    ensUniversalResolver: {
      address: '0xc8Af999e38273D658BE1b921b88A9Ddf005769cC',
      blockCreated: 5_317_080,
    },
  },
  testnet: true,
});

export const seiDevnet = defineChain({
  id: 713_715,
  name: 'Sei Devnet',
  iconUrl: 'https://img.cryptorank.io/coins/sei_network1661962346631.png',
  nativeCurrency: { name: 'Sei', symbol: 'SEI', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://evm-rpc-arctic-1.sei-apis.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Seitrace',
      url: 'https://seitrace.com',
    },
  },
  testnet: true,
});

export const bscTestnet = defineChain({
  id: 97,
  name: 'BSC Testnet',
  iconUrl: 'https://img.cryptorank.io/coins/bnb1732530324407.png',
  nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://bsc-testnet.publicnode.com'] },
  },
  blockExplorers: {
    default: {
      name: 'BSC Scan',
      url: 'https://testnet.bscscan.com',
    },
  },
});

export const avalancheTestnet = defineChain({
  id: 43113,
  name: 'Avalanche Testnet',
  iconUrl: 'https://img.cryptorank.io/coins/avalanche1629705441155.png',
  nativeCurrency: { name: 'Avalanche', symbol: 'AVAX', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://api.avax-test.network/ext/bc/C/rpc'] },
  },
  blockExplorers: {
    default: {
      name: 'Snowtrace',
      url: 'https://testnet.snowtrace.io',
    },
  },
});

export const baseTestnet = defineChain({
  id: 84531,
  name: 'Base sepolia',
  iconUrl:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/base/info/logo.png',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://base-sepolia.drpc.org'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Basescan',
      url: 'https://sepolia.basescan.org/',
    },
  },
});

export const optimismTestnet = defineChain({
  id: 11155420,
  name: 'Optimism sepolia',
  iconUrl: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11840.png',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://endpoints.omniatech.io/v1/op/sepolia/public'],
    },
  },
  blockExplorers: {
    default: {
      name: 'etherscan',
      url: 'https://sepolia-optimism.etherscan.io/',
    },
  },
});
export const polygonTestnet = defineChain({
  id: 80002,
  name: 'Polygon amoy',
  iconUrl: 'https://s2.coinmarketcap.com/static/img/coins/64x64/28321.png',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://polygon-amoy.drpc.org'],
    },
  },
  blockExplorers: {
    default: {
      name: 'polygonscan',
      url: 'https://amoy.polygonscan.com/',
    },
  },
});
